import accessibilityUtils from "@/utils/accessibility";
import { styled, Tab, tabClasses } from "@mui/material";

export const MurfTab = styled(Tab)(({ theme }) => ({
  fontWeight: 600,
  minHeight: 30,
  height: 30,
  minWidth: 96,
  opacity: 0.7,
  textTransform: "initial",
  fontSize: 13,
  padding: 0,
  borderRadius: theme.shape.borderRadius * 1,
  color: theme.palette.secondary.main,
  "&:hover": {
    opacity: 1
  },
  [`&.${tabClasses.selected}`]: {
    color: theme.palette.secondary.main,
    opacity: 1
  },
  [theme.breakpoints.up("md")]: {
    minWidth: 120
  },
  ["&:focus-visible"]: accessibilityUtils.generalFocusVisibleStyle
}));

export default MurfTab;
